module.exports = ".example-full-width {\n  width: 100%;\n}\n\n.push-down {\n  margin-bottom: 1em;\n}\n\n.mat-hint {\n  color: red;\n}\n"